import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { ImageDetails } from "../types/ImageDetailsType";

async function fetchTaskNoteImagesDetails(taskId: string) {
  return await httpClient.tasks.get<ImageDetails[]>(
    `/v1/task/${taskId}/notes/images`
  );
}

export function useTaskNotesImagesDetails(taskId: string) {
  return useQuery<ImageDetails[]>({
    queryKey: ["task", "notes", "images", taskId],
    queryFn: async () => await fetchTaskNoteImagesDetails(taskId),
    staleTime: INTERVAL.HOUR,
    enabled: !!taskId,
  });
}
